<template>
  <v-row class="campos">
    <v-col cols="12" md="4">
      <ValidationProvider name="CPF do responsável" rules="required|cpfValido" v-slot="{ errors }">
        <e-label>CPF do responsável</e-label>
        <v-text-field
          v-model="dados.responsavel_cpf"
          v-mask="'###.###.###-##'"
          inputmode="numeric"
          :error-messages="errors"
          dense
          solo
        />
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="8">
      <ValidationProvider name="Nome do responsável" rules="required|max:64" v-slot="{ errors }">
        <e-label>Nome do responsável</e-label>
        <v-text-field
          v-model="dados.responsavel_nome"
          counter="64"
          :error-messages="errors"
          dense
          solo
        />
      </ValidationProvider>
    </v-col>
    <v-col cols="12">
      <ValidationProvider
        name="E-mail do responsável"
        rules="required|email|max:64"
        v-slot="{ errors }"
      >
        <e-label>E-mail do responsável (receberá o código de confirmação)</e-label>
        <v-text-field
          v-model="dados.responsavel_email"
          type="email"
          autocomplete="email"
          counter="64"
          :error-messages="errors"
          dense
          solo
        />
      </ValidationProvider>
    </v-col>
    <v-col cols="12">
      <e-endereco-pre-matricula :dados="dados" prefixo="responsavel_" />
    </v-col>
  </v-row>
</template>

<script>
import EEnderecoPreMatricula from "./EEnderecoPreMatricula.vue";

/**
 * Pagador do boleto. Os tamanhos são os das colunas de `responsavels`, para onde a efetivação
 * copia estes dados. O endereço fica em EEnderecoPreMatricula, compartilhado com o aluno.
 */
export default {
  name: "EDadosDoPagador",
  components: { EEnderecoPreMatricula },
  props: {
    dados: { type: Object, required: true },
  },
};
</script>
